import React, { useState } from 'react';
import { Separator } from '@vaiu/ui/separator';
import { 
  Coins,
  AlertCircle
} from 'lucide-react';
import EthereumDepositFlow from '@/components/ethereum/EthereumDepositFlow';
import { EthereumProvider } from '@/context/EthereumContext';

interface PaymentMethodEthereumProps {
  amount: number;
  currency: string;
  onSuccess: (newBalance: number, fundingDetails?: any) => void;
  onError?: (error: string) => void;
  onCancel?: () => void;
  disabled?: boolean;
  className?: string;
  showSeparator?: boolean;
}

/**
 * PaymentMethodEthereum - Ethereum payment method component
 * Allows users to deposit ETH to fund their account
 */
export const PaymentMethodEthereum: React.FC<PaymentMethodEthereumProps> = ({
  amount,
  currency,
  onSuccess,
  onError,
  onCancel,
  disabled = false,
  className,
  showSeparator = true
}) => {
  // Note: EthereumDepositFlow handles its own deposit flow
  // This wrapper provides the interface for TopUpBalance integration
  // The actual deposit will be handled by EthereumDepositFlow which
  // will trigger balance updates that TopUpBalance can listen to

  return (
    <EthereumProvider>
      <div className={className}>
        {showSeparator && (
          <div className="flex items-center gap-4 my-4">
            <Separator className="flex-1" />
            <span className="text-sm text-muted-foreground">OR</span>
            <Separator className="flex-1" />
          </div>
        )}

        <div className="space-y-4">
          <div className="text-center py-2">
            <Coins className="w-8 h-8 mx-auto text-blue-500 mb-2" />
            <h3 className="font-medium">Pay with Ethereum</h3>
            <p className="text-sm text-muted-foreground">
              Deposit ETH to fund your account
            </p>
          </div>

          <EthereumDepositFlow />
        </div>
      </div>
    </EthereumProvider>
  );
};

